import icons from 'assets/icons'
import Button from 'components/formElements/Button'
import DefaultSelect from 'components/formElements/DefaultSelect'
import Spinner from 'components/loader/Spinner'
import Task from 'components/task/Task'
import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import { useRequest } from 'hooks/useRequest'
import { Paginator } from 'primereact/paginator'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { setTasks } from 'redux/features/tasks/tasksSlice'

const Tasks = () => {
	const navigate = useNavigate()
	const [filterOptions, setFilterOptions] = useState({ projectId: null, ticketStatusId: null, ticketPriorityId: null, ticketTypeId: null, searchString: '' })
	const [status, setStatus] = useState([])
	const [slice, setSlice] = useState({ start: 0, end: 8 })
	const [priority, setPriority] = useState([])
	const [type, setType] = useState([])
	const { tasks } = useSelector((state) => state)
	const { tasksData } = tasks
	const [getTasks, tasksLoading] = useRequest()
	const [getStatus] = useRequest()
	const [getPriority] = useRequest()
	const [getType] = useRequest()
	const dispatch = useDispatch()
	useEffect(() => {
		getTasks('/Ticket/GetAllTickets').then(res => {
			if (res.data.ok) {
				dispatch(setTasks(res.data.result))
			}
		})
		getStatus('/TicketStatus/GetAllTicketStatus').then(res => {
			if (res.data.ok) {
				setStatus(res.data.result)
			}
		})
		getPriority('/TicketPriority/GetAllTicketPriority').then(res => {
			if (res.data.ok) {
				setPriority(res.data.result)
			}
		})
		getType('/TicketType/GetAllTicketTypes').then(res => {
			if (res.data.ok) {
				setType(res.data.result)
			}
		})
	}, [])
	const handleChnage = (e, name) => {
		if (e == null) {
			setFilterOptions(prev => ({ ...prev, [name]: null }))
		} else {
			setFilterOptions(prev => ({ ...prev, [name]: e.value }))
		}
	}
	const filteredTasks = tasksData.filter(d => {
		const keys = Object.keys(filterOptions)
		let rt = [true]
		if (keys.length > 0) {
			keys.forEach(k => {
				if (filterOptions[k] != null) {
					if (k == 'ticketTypeId') {
						rt.push(d.ticketType.id == filterOptions.ticketTypeId)
					} else if (k == 'searchString') {
						rt.push(d.code.toLowerCase().includes(filterOptions[k].toLowerCase()) || d.title.toLowerCase().includes(filterOptions[k].toLowerCase()))
					}
					else {
						rt.push(d[k] == filterOptions[k])
					}
				}
			})
		}
		return rt.every(r => r)
	})
	return (
		<AnimatedSpan className='page-container d-flex flex-column'>
			<div className='row justify-content-between gap-3'>
				<div className='filters-left'>
					<div className='row filters-left-items w-100 d-flex align-items-center'>
						<div className="col-md-3 pl-0">
							<input type="text" placeholder='Görevlerde arayın' className="default-input" name='searchString' onChange={(e) => handleChnage(e.target, 'searchString')} />
						</div>
						<div className='col-md-3 pl-0'>
							<DefaultSelect
								placeholder='Durum'
								selectOptions={status.map(p => ({ label: p.name, value: p.id }))}
								handleChange={(e) => handleChnage(e, 'ticketStatusId')}
								isClearable
							/>
						</div>
						<div className='col-md-3 pl-0'>
							<DefaultSelect
								placeholder='Kritiklik Seviyesi'
								selectOptions={priority.map(p => ({ label: p.name, value: p.id }))}
								handleChange={(e) => handleChnage(e, 'ticketPriorityId')}
								isClearable
							/>
						</div>
						<div className='col-md-3 pl-0'>
							<DefaultSelect
								placeholder='Görev Tipi'
								selectOptions={type.map(p => ({ label: p.name, value: p.id }))}
								handleChange={(e) => handleChnage(e, 'ticketTypeId')}
								isClearable
							/>
						</div>
					</div>
				</div>
				<div className='filters-right'>
					<Button handleClick={() => navigate('create')} className='btn-success' title='Görev Oluştur' icon={<icons.plus />} zz />
				</div>
			</div>
			<div className='row mt-5 card tasks-card'>
				{filteredTasks.length > 0 && !tasksLoading ?
					<div className='tasks-list'>
						{filteredTasks.slice(slice.start, slice.end).map((task) => (
							<Task key={task.id} task={task} />
						))
						}
					</div>

					: tasksLoading ? <div className="row text-center">
						<div className="col-md-12">
							<Spinner size={3} />
						</div>
					</div>

						: <div className="row">
							<div className="col-md-12">
								<div className="heading-5 text-center">
									Veri Bulunamadi
								</div>
							</div>
						</div>}

			</div>
			{
				filteredTasks.length > 0 && <div className="row-margin-x mt-2">
					<div className="col-md-12">
						<div className="card p-1">
							<Paginator first={slice.start} rows={8} totalRecords={filteredTasks.length} onPageChange={(e) => { setSlice({ start: e.first, end: e.first + 9 }) }} />
						</div>
					</div>
				</div>
			}
		</AnimatedSpan>
	)
}

export default Tasks
